import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import PersonSearch from 'shell/components/shared/person-search';
import ActionsList from 'mutation/components/cancel-marriage/actions-list';
import { SearchPersonCancelMarriageCrumbs } from 'mutation/constants/cancel-marriage-crumbs';

const PersonsPageCancelMarriage = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={SearchPersonCancelMarriageCrumbs} />
      <PersonSearch
        pathname="/mutazioni/persona/matrimonio-annullamento/annullamento"
        action={ActionsList}
        addedTitle={'- Cessazione Matrimonio'}
      />
    </Fragment>
  );
};

PersonsPageCancelMarriage.displayName = 'Persons page component';

export default PersonsPageCancelMarriage;
